// A debit number range the customer's accounting assigns to EDM; `end: null` is open-ended
export type DebitNumberRange = { start: number; end: number | null };

export function isOutsideDebitNumberRange(debitNumber: string, range: DebitNumberRange): boolean {
  if (!/^\d+$/.test(debitNumber)) return true;
  const number = Number(debitNumber);
  return number < range.start || (range.end !== null && number > range.end);
}

export function debitNumberRangesOverlap(a: DebitNumberRange, b: DebitNumberRange): boolean {
  return (a.end === null || b.start <= a.end) && (b.end === null || a.start <= b.end);
}

// Settings deliver the bounds as number or string; an unset start means no range
export function debitNumberRange(
  start?: number | string | null,
  end?: number | string | null,
): DebitNumberRange | undefined {
  if (start == null || start === "") return undefined;
  return { start: Number(start), end: end == null || end === "" ? null : Number(end) };
}
